var map = {
	"./de-DE.json": [
		1847,
		2
	],
	"./en-GB.json": [
		1848,
		3
	],
	"./en-US.json": [
		1849,
		4
	],
	"./es-419.json": [
		1850,
		5
	],
	"./es-ES.json": [
		1851,
		6
	],
	"./fr-CA.json": [
		1852,
		7
	],
	"./fr-FR.json": [
		1853,
		8
	],
	"./id-ID.json": [
		1854,
		9
	],
	"./it-IT.json": [
		1855,
		10
	],
	"./ja-JP.json": [
		1856,
		11
	],
	"./nl-NL.json": [
		1857,
		12
	],
	"./pt-BR.json": [
		1858,
		13
	],
	"./zh-CN.json": [
		1859,
		14
	],
	"./zh-Hans-CN.json": [
		1860,
		15
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 938;
module.exports = webpackAsyncContext;